module.exports = __webpack_public_path__ + "img/Trollegate-grotta1.5428a35f.jpg";